import ProductCategoryPage from "../components/ProductCategoryPage.js";

export default function WhiteImportedMarble() {
  return (
    <ProductCategoryPage
      category="white"
      seoTitle="White Imported Marble in Kishangarh India | Italian White Marble – Square Feet Marble"
      seoDescription="Explore premium white imported & Italian marble slabs in Kishangarh. Ideal for luxury homes & hotels."
      canonical="https://www.squarefeetmarble.com/white-imported-marble-kishangarh.webp"
    />
  );
}
